import React, { useState } from "react";
import { Star, Leaf } from "lucide-react";
import { AnimatedSection } from "./shared";

const testimonials = [
  {
    name: "Priya & Karthik M.",
    location: "Bangalore",
    condition: "Fertility Support",
    result: "After 3 years of trying, we finally conceived naturally within 4 months of following Fitly's fertility nutrition program. The customized diet and Dr. Neelima's guidance changed everything for us!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1654764746576-20b2dea2efff?auto=format&fit=crop&w=200&h=200&crop=faces&q=80",
  },
  {
    name: "Sneha R.",
    location: "Chennai",
    condition: "PCOS & Irregular Cycles",
    result: "My periods were irregular for years. Within 2 months of the program, my cycles became regular. Lost 8 kgs and my hormones are finally balanced. Thank you Mrs. Nadiya and team!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1718965018802-897e94ce7f15?auto=format&fit=crop&w=200&h=200&crop=faces&q=80",
  },
  {
    name: "Anjali & Rahul S.",
    location: "Hyderabad",
    condition: "Low AMH & Male Factor",
    result: "We were told IVF was our only option. Fitly's couple program helped us both - my AMH improved and my husband's sperm count doubled. We're now expecting twins naturally!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1787318479102-eea147892d27?auto=format&fit=crop&w=200&h=200&crop=faces&q=80",
  },
  {
    name: "Deepika V.",
    location: "Mumbai",
    condition: "IVF Support",
    result: "Failed 2 IVF cycles before finding Fitly. Their pre-IVF nutrition protocol prepared my body perfectly. Third cycle was successful! The team's diet plan was a game-changer.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1760124146298-b1534ee3c9a0?auto=format&fit=crop&w=200&h=200&crop=faces&q=80",
  },
  {
    name: "Meenakshi K.",
    location: "Delhi",
    condition: "Thyroid & Weight Issues",
    result: "Lost 12 kgs in 3 months without any crash diet. My thyroid levels normalized and I conceived naturally after struggling for 2 years. Best decision we ever made!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1630001603446-585f8a8d5527?auto=format&fit=crop&w=200&h=200&crop=faces&q=80",
  },
  {
    name: "Lakshmi N.",
    location: "Bangalore",
    condition: "Recurrent Miscarriage",
    result: "After 2 miscarriages, I was devastated. Dr. Rekha's Ayurvedic approach combined with nutrition helped me carry my baby to full term. Now a proud mom of a healthy boy!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1706153068774-5271417921a4?auto=format&fit=crop&w=200&h=200&crop=faces&q=80",
  },
  {
    name: "Fathima & Irfan Z.",
    location: "Dubai",
    condition: "Unexplained Infertility",
    result: "We joined the online Elite program from Dubai after 4 years of unexplained infertility. Nadiya's personalized approach found gaps our doctors missed. Conceived in month 5!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1759495381902-180fd4aa95c2?auto=format&fit=crop&w=200&h=200&crop=faces&q=80",
  },
  {
    name: "Kavitha P.",
    location: "Coimbatore",
    condition: "Endometriosis & Fertility",
    result: "Living with Stage 3 endometriosis, I was losing hope. The anti-inflammatory diet plan and Ayurveda sessions reduced my pain dramatically. I'm now 14 weeks pregnant!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1691495257420-bc31c53097f2?auto=format&fit=crop&w=200&h=200&crop=faces&q=80",
  },
  {
    name: "Swathi & Arun D.",
    location: "Bangalore",
    condition: "Pregnancy Nutrition",
    result: "Joined Premium Plus for our entire pregnancy journey. The trimester-wise nutrition plans gave us so much confidence. Our little one is healthy and thriving!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1759495382504-69d5b10ae695?auto=format&fit=crop&w=200&h=200&crop=faces&q=80",
  },
  {
    name: "Roshni G.",
    location: "Pune",
    condition: "PCOS & Insulin Resistance",
    result: "My fasting insulin was 28 and I had severe PCOS. Within 3 months, insulin dropped to 9, lost 10 kgs, and my cycles returned on their own. Truly life-changing!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1764078682636-151f730ccbd4?auto=format&fit=crop&w=200&h=200&crop=faces&q=80",
  },
];

const TestimonialCard = ({ t, idx }) => (
  <div
    data-testid={`testimonial-card-${idx}`}
    className="bg-[#FEFDFB]/[0.04] border border-[#FEFDFB]/10 p-6 hover:bg-[#FEFDFB]/[0.08] hover:border-[#D4AF37]/20 transition-all duration-300 flex flex-col rounded-xl group"
  >
    <div className="flex gap-1 mb-4">
      {[...Array(t.rating)].map((_, i) => (
        <Star key={`star-${i}`} className="w-4 h-4 fill-[#D4AF37] text-[#D4AF37]" />
      ))}
    </div>
    <p className="text-[#FEFDFB]/75 text-sm leading-relaxed flex-1 mb-6">
      &ldquo;{t.result}&rdquo;
    </p>
    <div className="flex items-center gap-3 pt-4 border-t border-[#FEFDFB]/10">
      <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-[#D4AF37]/25 group-hover:border-[#D4AF37]/50 transition-colors flex-shrink-0 shadow-lg shadow-black/20">
        <img
          src={t.image}
          alt={t.name}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>
      <div>
        <p className="text-[#FEFDFB] text-sm font-medium">{t.name}</p>
        <p className="text-xs text-[#FEFDFB]/45">{t.location} — {t.condition}</p>
      </div>
    </div>
  </div>
);

const TestimonialsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? testimonials : testimonials.slice(0, 3);
  const desktopVisible = showAll ? testimonials : testimonials.slice(0, 6);

  return (
    <section
      data-testid="testimonials-section"
      className="py-24 md:py-32 bg-[#0D1F17] relative overflow-hidden"
    >
      {/* Decorative dot pattern */}
      <div
        className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{
          backgroundImage: "radial-gradient(circle, #D4AF37 1px, transparent 1px)",
          backgroundSize: "50px 50px",
        }}
      />
      {/* Ambient glow */}
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-[#D4AF37]/[0.02] rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <AnimatedSection>
          <div className="text-center mb-16">
            <span className="inline-flex items-center gap-1.5 text-xs tracking-[0.2em] uppercase font-semibold text-[#D4AF37]">
              <Leaf size={12} />
              4.9 Rating | 114+ Reviews
            </span>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight text-[#FEFDFB] mt-3">
              Real Stories, <span className="italic font-light text-[#D4AF37]">Real Results</span>
            </h2>
          </div>
        </AnimatedSection>

        {/* Mobile: vertical stack */}
        <div className="sm:hidden space-y-4" data-testid="testimonials-mobile-list">
          {visible.map((t, idx) => (
            <TestimonialCard key={t.name} t={t} idx={idx} />
          ))}
        </div>

        {/* Desktop: grid layout */}
        <div className="hidden sm:grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {desktopVisible.map((t, idx) => (
            <AnimatedSection key={t.name} delay={idx * 0.05}>
              <TestimonialCard t={t} idx={idx} />
            </AnimatedSection>
          ))}
        </div>

        {testimonials.length > 3 && (
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-10">
            <button
              onClick={() => setShowAll(!showAll)}
              data-testid="testimonials-show-more-btn"
              className="border border-[#FEFDFB]/15 text-[#FEFDFB] px-8 py-3 text-sm tracking-wide hover:bg-[#FEFDFB]/10 transition-all rounded-full"
            >
              {showAll ? "Show Less" : "Show More Reviews"}
            </button>
            <a
              href="/success-stories"
              data-testid="view-success-stories"
              className="bg-[#D4AF37] text-[#0D1F17] px-8 py-3 text-sm tracking-wide hover:bg-[#E8D48B] transition-all rounded-full font-medium"
            >
              View Full Success Stories
            </a>
          </div>
        )}
      </div>
    </section>
  );
};

export default TestimonialsSection;
